import React, { Component, Fragment } from "react";
import callIcon from "./../../globals/images/call-icon.svg";
import endCallIcon from "./../../globals/images/end-call.png";
import Confirmation from "./../../components/commonComponents/confirmationBox";
import getLabel from './../../utils/labels'
import "./call.css";
import Chat from "./../container/chat";
import Timer from "../callTimer/timer";
import _ from "lodash";

class Call extends Component {
	constructor() {
		super();
		this.state = {
			chatData: [],
			isTimerOn: true,
			closeCall: false,
			completed: false,
			isConfirmationBoxOpen: false
		};
	}
	chatDataSetter = chatData => {
		this.setState({
			chatData
		});
	};

	chatCompleted = () => {
		let callAnswers = this.state.chatData.filter(
			chat => chat.type === "mcq"
		);
		callAnswers = callAnswers.map(chat => {
			return {
				questionId: chat.id,
				optionId: chat.userOptionId
			};
		});

		let callPostData = {
			primaryMailId: this.props.callDetail.id,
			surveyId: 2,
			actionTakenAt: this.getCurrentTime(),
			surveyAnswers: callAnswers
		};

		if (!window.location.href.includes("tutorial")) {
			//disable when tutorial is running
			this.props.postSurveyResponse(callPostData).then(response => {
				if (response.sucess) {
					this.setState({
						completed: true
					});
					this.stopTimer(3000);
				}
			});
		} else {
			this.setState({
				completed: true
			});
			this.stopTimer(3000);
		}
	};

	stopTimer = (time = 100) => {
		this.setState({
			isTimerOn: false
		});

		//disable post api when call is running
		if (!window.location.href.includes("tutorial")) {
			//disable when tutorial is running
			this.props
				.terminateCall({
					primaryMailId: this.props.callDetail.id
				})
				.then(response => {
					if (response.sucess) {
						this.timerForCall = setTimeout(() => {
							this.endCallDialog();
							this.props.setCallEndedFlag({
								primaryMailId: this.props.callDetail.id
							});
							this.props.endCall();
						}, time);
					}
				});
		} else {
			this.timerForCall = setTimeout(() => {
				this.endCallDialog();
				this.props.setCallEndedFlag({
					primaryMailId: this.props.callDetail.id
				});
				this.props.endCall();
			}, time);
		}
	};

	getCurrentTime = () => {
		return this.props.getTimeData().timeLeft;
	};

	endCallDialog = () => {
		this.props.closeCallContainer();
	};

	openConfirmationBox = () => {
		if (!window.location.href.includes("tutorial")) {
			//disable when tutorial is running
			this.setState({
				isConfirmationBoxOpen: true
			});
		}
	};

	closeConfirmationBox = () => {
		this.setState({
			isConfirmationBoxOpen: false
		});
	};

	render() {
		let { statements, questions } = this.props.callDetail.survey;
		statements = _.orderBy(statements, ['id'], ['asc'])
		questions = _.orderBy(questions, ['id'], ['asc'])

		let fromActorId = this.props.callDetail.survey.fromActor;

		let isRightHighLight = this.state.chatData.length % 2 === 1;
		if (this.state.chatData.slice(-1)[0]) {
			isRightHighLight = this.state.chatData.slice(-1)[0].fromActor === this.props.selfActor;
		}
		let isLefttHighLight = !isRightHighLight;
		// const isRightHighLight = true;

		const selfActorId = this.props.selfActor;
		let selfActor = this.props.actors.inActors.find(
			actor => actor.id === selfActorId
		);

		const allActors = [...this.props.actors.inActors, ...this.props.actors.clients]
		let fromActor = allActors.find(
			actor => actor.id === fromActorId
		);
		// const isLefttHighLight = false;
		return (
			<Fragment>
				<div className="call-layout chat-text">
					<div className="actors-block">
						<div className="img-embed">
							<div className="left-actor">
								{isLefttHighLight ? (
									<div className="concentric-circles">
										<img src={fromActor.gravatar} />
									</div>
								) : (
										<img src={fromActor.gravatar} />
									)}
								<div className="actor-name">
									{fromActor.first_name}
								</div>
							</div>
							<div className="hor-line">
								{!this.state.completed && (
									<img src={callIcon} className="call-icon" />
								)}
							</div>
							<div className="right-actor">
								{isRightHighLight ? (
									<div className="concentric-circles">
										<img src={selfActor.gravatar} />
									</div>
								) : (
										<img src={selfActor.gravatar} />
									)}
								<div className="actor-name">
									{selfActor.first_name} ({getLabel('label_character_you')})
								</div>
							</div>
						</div>
						<div className="line-through" />
						{
							<div
								className="call-info"
								style={
									this.state.completed
										? { visibility: "hidden" }
										: {}
								}
							>
								<span>{getLabel('label_on_call')}</span>
								<Timer
									isTimerOn={this.state.isTimerOn}
									closeCall={this.props.closeCall}
								/>
							</div>
						}
					</div>
					<Chat
						chatDataSetter={this.chatDataSetter}
						chatCompleted={this.chatCompleted}
						questions={questions}
						statements={statements}
						selfActor={selfActorId}
						selfActorImage={selfActor.gravatar}
						fromActorImage={fromActor.gravatar}
						actors={this.props.actors}
						width={880}
						//For tutorial
						tutorial={this.props.tutorial}
						startTutorial={this.props.startTutorial}
						stopTutorial={this.props.stopTutorial}
						addStepsToTutorial={this.props.addStepsToTutorial}
						updateStepNumber={this.props.updateStepNumber}
						setEndTutorialPopup={this.props.setEndTutorialPopup}
					/>
					<div className="call-footer">
						<img
							src={endCallIcon}
							style={{ margin: "0 10px", cursor: "pointer" }}
							onClick={this.openConfirmationBox}
						/>
					</div>
					{this.state.completed && (
						<div className="call-ended">
							<div>{getLabel('label_call_ended')}</div>
						</div>
					)}
				</div>
				{this.state.isConfirmationBoxOpen ? (
					<Confirmation
						acceptButtonText={getLabel('label_end_button')}
						confimationMessage={getLabel('label_call_end_confirmation')}
						onAcceptClick={this.stopTimer}
						onCancelClick={this.closeConfirmationBox}
					/>
				) : null}
			</Fragment>
		);
	}
}

export default Call;



// WEBPACK FOOTER //
// /src/call/call/call.js